module.exports = __webpack_public_path__ + "media/offers/offer-pion-black-e587fb27.png";